import { TransactionsList } from "components/transactions/TransactionsList";
import Layout from "components/Layout";

export const TransactionsPage = () => {
  return (
    <Layout title="Transactions" content="Transactions page">
      <TransactionsList />
    </Layout>
  );
};
